<template>
    <div class="">
        <h2 class="export-title text-center">Select Your CAD Format</h2>
        <ul class="export-listing">
            <ExportGroup v-for="formatGroup in exportData.exportGroups" v-bind:formatGroup="formatGroup" v-bind:key="formatGroup.id" v-bind:values="exportValues"></ExportGroup>
        </ul>
        <ul class="export-listing">
            <ExportOptionSelection v-for="option in exportData.exportOptionViewModels" :key="option.id" v-bind:optionContent="option" v-bind:values="exportValues"></ExportOptionSelection>
        </ul>
        <div class="d-flex justify-content-center">
            <ul class="consent-listing custom-control custom-checkbox pb-2">
                <li v-for="consent in exportData.exportConsentViewModels" :key="consent.id">
                    <input class="custom-control-input consentRequest" v-bind:class="[{required: consent.required}]" v-bind:aria-required="consent.required" v-bind:id="consent.name" type="checkbox" v-model="consent.checked" />
                    <label class="custom-control-label" v-bind:for="consent.name"><span v-html="consent.content"></span></label>
                    <span v-if="consent.required" class="required">*</span>
                </li>
            </ul>
        </div>
        <LicenseModal></LicenseModal>
        <div class="d-flex flex-column align-items-center justify-content-center mt-2 mb-2">
            <a class="btn btn-dark" v-show="userContent.loggedin" v-bind:disabled="!enableExport(exportData, exportValues)" v-on:click="enableExport(exportData, exportValues) && exportPart(exportData, exportValues)">Download Now</a>
            <a class="btn btn-dark" v-show="!userContent.loggedin" @click="openLogin()">Login To Download</a>
        </div>
    </div>
</template>

<script>
    import ExportGroup from './ExportGroup.vue';
    import ExportOptionSelection from './ExportOptionSelection.vue';
    import LicenseModal from './LicenseModal.vue';

    export default {
        name: 'ExportPanel',
        components: {
            ExportGroup,
            ExportOptionSelection,
            LicenseModal
        },
        props: {
            exportData: {
                type: Object,
                default: () => {
                    return {
                        exportGroups: [],
                        exportOptionViewModels: [],
                        exportConsentViewModels: [],
                        distributorPartNumbers:[],
                        partUniqueId: ""
                    }
                }
            },
            exportValues: {
                type: Object,
                default: () => {
                    return {
                        requestedExports: [],
                        max: 5
                    }
                }
            },
            userContent: {
                type: Object,
                default: () => {
                    return {
                        loggedin: false,
                        username: ""
                    }
                }
            }
        },
        methods: {
            exportPart(exportData, exportValues) {
                //grab part uuid
                var puid = exportData.partUniqueId;
                //grab selected export formats;
                var exportFormats = exportValues.requestedExports;
                //grab defined export options
                var exportOptions = [];
                //grab distributor parts
                var dpns = exportData.distributorPartNumbers;
                //grab export consents
                var consentOptions = [];

                for (var i = 0; i < exportData.exportOptionViewModels.length; i++) {
                    exportOptions.push(exportData.exportOptionViewModels[i].selectedValue);
                }

                for (var k = 0; k < exportData.exportConsentViewModels.length; k++) {
                    if (exportData.exportConsentViewModels[k].checked) {
                        consentOptions.push(exportData.exportConsentViewModels[k].id);
                    }
                }

                exportValues.requestedExports = [];

                this.$root.$emit('export_part', puid, exportFormats, exportOptions, dpns, consentOptions);
            },
            enableExport(exportData, exportValues) {
                var test = true; 
                //At least one value selected
                if (exportValues.requestedExports != null)
                    test = test && exportValues.requestedExports.length > 0;
                //All requried fields selected
                if (exportData.exportConsentViewModels != null) {
                    for (var i = 0; i < exportData.exportConsentViewModels.length; i++) {
                        if (exportData.exportConsentViewModels[i].required) {
                            test = test && exportData.exportConsentViewModels[i].checked;
                        }
                    }
                }

                return test;
            },
            openLogin() {
                this.$root.$emit('show_login');
            }
        }
    };
</script>

<style>
    .export-listing, .consent-listing {
        column-count: 1;
        list-style-type: none;
        padding: 0px;
    }

    .export-listing li, .consent-listing li{
        padding: 0px;
    }

    .consent-listing {
        margin: 0em 2em;
    }

    @media (min-width: 1300px) {
        .export-listing {
            column-count: 2;
        }

        .export-listing li {
            overflow: hidden; /* fix for Firefox */
            break-inside: avoid-column;
            -webkit-column-break-inside: avoid;
        }
    }

    .export-group {
        border: none;
    }

    .export-group > .card-header {
        background-color: var(--ul-light-gray-bg);
        border-bottom: 1px solid var(--ul-dark-gray);
        padding: 0;
    }

    .export-group .card-body {
        background-color: var(--ul-light-gray-bg);
    }

    .card-body{
        padding: 0em;
    }

    .export-title {
        color: var(--ul-dark-gray);
    }

    .export-group > .card-header > a.accordion-toggle {
        color: var(--ul-dark-gray);
        display: block;
        padding: 0;
        cursor: pointer;
        text-decoration: none;
    }

    .export-group > .card-header > a.accordion-toggle:before {
        /* symbol for "opening" panels */
        content: "\25bc";
    }

    .export-group > .card-header > a.accordion-toggle.collapsed:before {
        /* symbol for "collapsed" panels */
        content: "\25b6";
    }
</style>